<template>
	<div class="company-profile-box">
		<div class="company-profile-container">
			<!-- 公司简介 -->
			<div class="profile-section company-intro-section">
				<div class="section-header" @click="goMore('about_intro')">
					<div class="section-title">{{ companyIntro.title }}</div>
					<div class="view-more">{{ $t('enterprise.see-more') }}<i class="iconfont iconjiantouyou"></i></div>
				</div>
				<div class="intro-content">
					{{ companyIntro.summary }}
				</div>
			</div>

			<!-- 最新数据 -->
			<div class="profile-section data-section">
				<div class="data-header">
					<div class="data-title">{{ latestData.title }}</div>
					<div class="data-subtitle">{{ latestData.subtitle }}</div>
				</div>
				<div class="data-grid">
					<div v-for="(metric, index) in latestData.metrics" :key="index" class="data-item">
						<div class="data-value-row">
							<span class="data-value">{{ metric.value }}</span>
							<span class="data-unit">{{ metric.unit }}</span>
						</div>
						<div class="data-label">{{ metric.label }}</div>
						<div v-if="metric.note" class="data-note">{{ metric.note }}</div>
					</div>
				</div>
			</div>

			<!-- 公司治理 -->
			<div class="profile-section governance-section">
				<div class="section-header" @click="goMore('about_governance')">
					<div class="section-title">{{ governance.title }}</div>
					<div class="view-more">{{ $t('enterprise.see-more') }}<i class="iconfont iconjiantouyou"></i></div>
				</div>
				<div class="governance-content">
					{{ governance.content }}
				</div>
			</div>

			<!-- 董监高简介 -->
			<div v-if="getOverviewMember.length > 0" class="profile-section executives-section">
				<div class="section-header" @click="goGovernanceMore">
					<div class="section-title">{{ executives.title }}</div>
					<div class="view-more">{{ $t('enterprise.see-more') }}<i class="iconfont iconjiantouyou"></i></div>
				</div>
				<div class="executives-list">
					<div v-for="(executive, index) in getOverviewMember" :key="index" class="executive-item">
						<div class="executive-name">{{ executive.name }}</div>
						<div v-if="executive.position" class="executive-title">{{ executive.position }}</div>
						<div v-if="executive.abstractText" class="executive-description">
							{{ executive.abstractText }}
						</div>
					</div>
				</div>
			</div>

			<!-- 联系我们 -->
			<div class="profile-section contact-section">
				<div class="section-header">
					<div class="section-title">{{ contactInfo.title }}</div>
				</div>
				<div class="contact-list">
					<div class="contact-item">
						<span class="contact-label">地址：</span>
						<span class="contact-value">{{ contactInfo.address }}</span>
					</div>
					<div class="contact-item">
						<span class="contact-label">官网：</span>
						<span class="contact-value">{{ contactInfo.website }}</span>
					</div>
					<div class="contact-item">
						<span class="contact-label">邮箱：</span>
						<span class="contact-value">{{ contactInfo.email }}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { computed } from 'vue';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';
import { useModuleConfig } from '@rebuild/hooks/data/useModuleConfig';
import { useNavigation } from '@rebuild/hooks/useNavigation';
import { useCurrentContext } from './context';

export default {
	data() {
		return {};
	},
	mounted() {
		this.loadModule();
	},
	methods: {
		loadModule() {
			this.loadGovernanceData();
		}
	},
	setup() {
		const context = useCurrentContext();

		const { config, loadModuleConfig } = useModuleConfig();
		const getOptions = computed(() => {
			if (!config.value?.displayDepartment) return [];
			return config.value.displayDepartment.filter(item => item.isSelected).sort((a, b) => a.sort - b.sort);
		});

		const { corporate_governance } = useModuleData();
		const loadGovernanceData = async () => {
			await loadModuleConfig('corporate_governance');
			await corporate_governance.refresh();
		};
		const getGovernanceData = computed(() => {
			return corporate_governance.data?.data || [];
		});
		const getOverviewMember = computed(() => {
			const enabledOptions = getOptions.value.map(item => item.value);
			const memberList = getGovernanceData.value;
			const result = [];

			memberList.forEach(item => {
				const depValues = item.type.split(',').map(item => Number(item));
				if (enabledOptions.some(option => depValues.includes(option))) {
					result.push(item);
				}
			});

			const uniqueResult = result.reduce((prev, cur) => {
				if (!prev.some(item => item.id === cur.id)) {
					prev.push(cur);
				}
				return prev;
			}, []);
			return uniqueResult.slice(0, 2);
		});

		const { goToModule } = useNavigation();
		const goGovernanceMore = () => {
			goToModule('corporate_governance');
		};
		const goMore = type => {
			goToModule('company_profile_hk00656', {
				type
			});
		};

		return {
			companyIntro: context.companyIntro,
			latestData: context.latestData,
			governance: context.governance,
			executives: context.executives,
			contactInfo: context.contactInfo,

			getOptions,
			loadGovernanceData,
			getGovernanceData,
			getOverviewMember,
			goGovernanceMore,
			goMore
		};
	}
};
</script>

<style lang="less" scoped>
@import '@/style/mixins';

.company-profile-container {
	background: #f7f7f7;
}

.profile-section {
	padding: 0.16rem 0.12rem 0.12rem;
	background: #fff;
	overflow: hidden;

	& + .profile-section {
		margin-top: 0.08rem;
	}

	.section-header {
		padding: 0 0.02rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 0.12rem;

		.section-title {
			color: #666;
			font-family: 'PingFang SC';
			font-size: 0.13rem;
			line-height: 0.18rem; /* 138.462% */
			font-style: normal;
			font-weight: 400;
		}

		.view-more {
			display: flex;
			align-items: center;
			color: #666;
			font-family: 'PingFang SC';
			font-size: 0.11rem;
			font-style: normal;
			font-weight: 400;

			.iconfont {
				margin-left: 0.02rem;
				font-size: 0.1rem;
			}
		}
	}
}

.company-intro-section {
	.intro-content {
		color: #333;
		font-family: 'PingFang SC';
		font-size: 0.15rem;
		font-style: normal;
		font-weight: 400;
		line-height: normal;
		letter-spacing: 1px;

		.text-overflow-multi-row(6);
	}
}

.data-section {
	.data-header {
		display: flex;
		align-items: baseline;
		margin-bottom: 0.12rem;

		.data-title {
			color: #666;
			font-family: 'PingFang SC';
			font-size: 0.13rem;
			font-style: normal;
			font-weight: 400;
			line-height: 0.18rem;
		}

		.data-subtitle {
			color: #666;
			font-family: 'PingFang SC';
			font-size: 0.1rem;
			font-style: normal;
			font-weight: 400;
			line-height: 0.18rem;
		}
	}

	.data-grid {
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		gap: 0.12rem;

		.data-item {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			text-align: center;
			gap: 0.08rem;
			border-radius: 4px;
			background: #f7f8fa;
			height: 0.96rem;

			.data-value-row {
				display: flex;
				align-items: baseline;
			}
			.data-value {
				color: #1d2129;
				font-family: 'DIN Alternate';
				font-size: 0.24rem;
				font-style: normal;
				font-weight: 700;
				line-height: 0.28rem; /* 116.667% */
			}
			.data-unit {
				margin-left: 0.08rem;
				color: #86909c;
				font-family: 'PingFang SC';
				font-size: 0.13rem;
				font-style: normal;
				font-weight: 400;
				line-height: 0.2rem; /* 153.846% */
			}
			.data-label {
				color: #86909c;
				text-align: center;
				font-family: 'PingFang SC';
				font-size: 0.13rem;
				font-style: normal;
				font-weight: 400;
				line-height: 0.2rem; /* 153.846% */
			}
			.data-note {
				color: #1d2129;
				text-align: center;
				font-family: 'PingFang SC';
				font-size: 0.1rem;
				font-style: normal;
				font-weight: 400;
				line-height: 0.14rem; /* 140% */
			}
		}
	}
}

.governance-section {
	.governance-content {
		color: #333;
		font-family: 'PingFang SC';
		font-size: 0.15rem;
		font-style: normal;
		font-weight: 400;
		line-height: normal;
		letter-spacing: 1px;
		.text-overflow-multi-row(5);
	}
}

.executives-section {
	.executives-list {
		.executive-item {
			.executive-name {
				color: #1d2129;
				font-family: 'PingFang SC';
				font-size: 0.18rem;
				font-style: normal;
				font-weight: 600;
				line-height: normal;
			}

			.executive-title {
				margin-top: 0.02rem;
				color: #86909c;
				font-family: 'PingFang SC';
				font-size: 0.12rem;
				font-style: normal;
				font-weight: 400;
				line-height: 0.18rem; /* 150% */
			}

			.executive-description {
				margin-top: 0.16rem;
				color: #1d2129;
				text-align: justify;
				font-family: 'PingFang SC';
				font-size: 0.14rem;
				font-style: normal;
				font-weight: 400;
				line-height: 0.24rem; /* 171.429% */
				.text-overflow-multi-row(3);
			}
		}

		.executive-item {
			overflow: hidden;

			&::after {
				content: '';
				display: block;
				margin: 0.16rem 0;
				width: 100%;
				height: 1px;
				background-color: #e5e6eb;
				transform: scaleY(0.5);
			}

			&:last-child {
				&::after {
					display: none;
				}
			}
		}
	}
}

.contact-section {
	.contact-list {
		display: flex;
		flex-direction: column;
		gap: 0.2rem;

		.contact-item {
			display: flex;
			align-items: flex-start;

			.contact-label {
				width: 0.66rem;
				color: #86909c;
				font-family: 'PingFang SC';
				font-size: 0.14rem;
				font-style: normal;
				font-weight: 400;
				line-height: 0.18rem; /* 128.571% */
			}

			.contact-value {
				flex: 1;
				width: 0;
				color: #1d2129;
				font-family: 'PingFang SC';
				font-size: 0.14rem;
				font-style: normal;
				font-weight: 400;
				line-height: 0.18rem; /* 128.571% */
			}
		}
	}
}
</style>
